// src/redux/api/transactionApi.js
import { withDefaultMeta } from "../../util/withDefaultMeta";
import { apiSlice } from "../../app/apiSlice";

export const transactionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);

    return {
      // Get all transactions (admin)
      getAllTransactions: query({
        query: () => ({
          url: "/transactions",
          method: "GET",
        }),
        providesTags: ["Transactions"],
      }),

      // Get transactions by subscription
      getTransactionsBySubscription: query({
        query: (subscriptionId) => ({
          url: `/transactions/subscription/${subscriptionId}`,
          method: "GET",
        }),
        providesTags: (result, error, arg) =>
          result
            ? [...result.map(({ _id }) => ({ type: "Transactions", id: _id }))]
            : ["Transactions"],
      }),

      // Get transactions by user
      getTransactionsByUser: query({
        query: (userId) => ({
          url: `/transactions/user/${userId}`,
          method: "GET",
        }),
        providesTags: (result, error, arg) =>
          result
            ? [...result.map(({ _id }) => ({ type: "Transactions", id: _id }))]
            : ["Transactions"],
      }),

      // Refund a transaction
      refundTransaction: mutation({
        query: ({ id, amount }) => ({
          url: `/transactions/${id}/refund`,
          method: "POST",
          body: { amount },
        }),
        invalidatesTags: ["Transactions"],
      }),
    };
  },
});

export const {
  useGetAllTransactionsQuery,
  useGetTransactionsBySubscriptionQuery,
  useGetTransactionsByUserQuery,
  useRefundTransactionMutation,
} = transactionApiSlice;
